<h2>Cashback. История начисления</h2>
<div class="container cashback-history-content">
  <div class="filter-container">
    <app-date-filter (dateFilter)="changeDateFilter($event)"></app-date-filter>
    <button mat-stroked-button color="warn" (click)="resetCashback()">Сбросить cashback</button>
  </div>
  <div class="cashback-history-table-container">
    <div class="progress-bar" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-table [dataSource]="userCashbackHistoryData" class="table cashback-history-table" matSort #cashbackTable>

      <!-- count Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef> #</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{i + 1}}</mat-cell>
      </ng-container>

      <!-- gameTypeId Column -->
      <ng-container matColumnDef="gameTypeId">
        <mat-header-cell *matHeaderCellDef>Игра (тип)</mat-header-cell>
        <mat-cell *matCellDef="let element">{{logType[element.gameTypeId]}}</mat-cell>
      </ng-container>

      <!-- gameId Column -->
      <ng-container matColumnDef="gameId">
        <mat-header-cell *matHeaderCellDef>Игра (ID)</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.gameId}}</mat-cell>
      </ng-container>

      <!-- amount Column -->
      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Сумма</mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span
              matTooltip="{{element.amount | fastCoinsToDollar}}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast"
            >
            {{element.amount / 100 }}
            </span></mat-cell>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Дата</mat-header-cell>
        <mat-cell *matCellDef="let element">  {{element.ts | date: 'dd.MM.yy HH:mm'}}</mat-cell>
      </ng-container>

      <!-- isTaken Column -->
      <ng-container matColumnDef="isTaken">
        <mat-header-cell *matHeaderCellDef>Взято</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.isTaken ? 'Да' : 'Нет' }} </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="userCashbackHistoryColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: userCashbackHistoryColumns;"></mat-row>

      <div class="empty-data" *matNoDataRow>
        <p>Данные отсутствуют</p>
      </div>
    </mat-table>
    <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
    </mat-paginator>
  </div>
</div>
